import { useContext as t } from "react";
import o from "../../DocumentContext.es.js";
function r() {
  return t(o);
}
export {
  r as default
};
//# sourceMappingURL=useDocumentContext.es.js.map
